export const WORKSPACE_KEY = "workspace-v1";

export class WorkspacePersistenceError extends Error {
  constructor(message: string, options?: ErrorOptions) {
    super(message, options);
    this.name = "WorkspacePersistenceError";
  }
}
